import { getDisplayedValue } from 'customer-data-property-utils/PropertyValueDisplay';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import useOptionColors, { decoratorColorToBadgeMap } from '../../input/select/useOptionColors';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import { decoratorColorToHexColorMap } from 'customer-data-property-utils/optionDecoratorUtils';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FormattedPropertyDisplayedValue = ({
  property,
  propertyValue,
  dateFormat,
  dateTimeFormat,
  relativeDate,
  relativeDateTime,
  objectTypeId,
  placeholder,
  dataAttributes
}) => {
  useComponentMountMetric('FormattedPropertyDisplayedValue');
  const {
    colorByOptionValue,
    shouldUseOptionColors,
    shouldUseBadgeDisplay
  } = useOptionColors();
  const displayedValue = getDisplayedValue(property, propertyValue, undefined, {
    dateFormat,
    dateTimeFormat,
    relativeDate,
    relativeDateTime,
    showDateDisplayHintLabel: true
  }, objectTypeId) || placeholder;
  if (shouldUseBadgeDisplay && propertyValue) {
    var _colorByOptionValue$S;
    const badgeColor = ((_colorByOptionValue$S = colorByOptionValue[String(propertyValue)]) === null || _colorByOptionValue$S === void 0 ? void 0 : _colorByOptionValue$S.badgeColor) || decoratorColorToBadgeMap.GRAY;
    return /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
      children: /*#__PURE__*/_jsx(Badge, {
        use: badgeColor,
        "data-test-badge-use": badgeColor,
        "data-test-id": "badge",
        children: displayedValue
      })
    }));
  }
  if (shouldUseOptionColors && propertyValue) {
    var _colorByOptionValue$S2;
    const statusDotColor = ((_colorByOptionValue$S2 = colorByOptionValue[String(propertyValue)]) === null || _colorByOptionValue$S2 === void 0 ? void 0 : _colorByOptionValue$S2.hexColor) || decoratorColorToHexColorMap.GRAY;
    return /*#__PURE__*/_jsxs("span", Object.assign({}, dataAttributes, {
      children: [/*#__PURE__*/_jsx(UIStatusDot, {
        role: "status",
        color: statusDotColor,
        "data-test-color": statusDotColor
      }), displayedValue]
    }));
  }
  return /*#__PURE__*/_jsx("span", Object.assign({}, dataAttributes, {
    children: displayedValue
  }));
};